export default __webpack_public_path__ + "static/media/phase4-line.69f1a78f.svg";